module.exports = __webpack_public_path__ + "static/img/m_name.fb85fbe.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/yjyx/m_name.png
// module id = DqWt
// module chunks = 7